import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExperienceComponent } from './components/experience/experience.component';
import { ExperienceHeaderComponent } from './components/experience-header/experience-header.component';
import { ExperienceTitleComponent } from './components/experience-title/experience-title.component';
import { ExperienceGalleryComponent } from './components/experience-gallery/experience-gallery.component';
import { ExperienceEditorViewComponent } from './components/experience-editor-view/experience-editor-view.component';
import { ExperienceEditorTipsComponent } from './components/experience-editor-tips/experience-editor-tips.component';
import { ExperienceLoveSlideshowComponent } from '@features/experience/components/experience-love-slideshow/experience-love-slideshow.component';
import { ExperienceBenefitsComponent } from './components/experience-benefits/experience-benefits.component';
import { ExperienceMapComponent } from './components/experience-map/experience-map.component';
import { ExperienceRoutingModule } from '@features/experience/experience-routing.module';
import { FooterModule } from '@shared/footer/footer.module';
import { OpenConfirmationComponent } from '@features/experience/components/open-confirmation/open-confirmation.component';
import { ExperienceDetailsDialogComponent } from './components/experience-details-dialog/experience-details-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ExperienceInsidersComponent } from './components/experience-insiders/experience-insiders.component';
import { ExperienceSelfExploreDesktopComponent } from './components/experience-self-explore-desktop/experience-self-explore-desktop.component';
import { ExperienceInsidersGalleryComponent } from '@features/experience/components/experience-insiders-gallery/experience-insiders-gallery.component';
import { ResizeImagePipe, SwiperDirective, SwiperSlideDirective } from '@ess-front/shared';
import { ExperienceSelfExploreMobileComponent } from './components/experience-self-explore-mobile/experience-self-explore-mobile.component';
import { SelfExploreModalComponent } from './components/self-explore-modal/self-explore-modal.component';
import { ExperienceModalCardComponent } from './components/experience-modal-card/experience-modal-card.component';
import { LoadModule } from '@shared/load/load.module';
import { MatMenuModule } from '@angular/material/menu';
import { ButtonComponent } from '@shared/button/button.component';
import { TranslocoDirective } from '@jsverse/transloco';
import { EssDatePipe } from '@shared/pipes/ess-date/ess-date.pipe';
import { BenefitsBoxComponent } from '@shared/benefits-box/benefits-box.component';
import { TagComponent } from '@shared/tag/tag.component';

@NgModule({
  declarations: [
    ExperienceComponent,
    ExperienceHeaderComponent,
    ExperienceTitleComponent,
    ExperienceGalleryComponent,
    ExperienceEditorViewComponent,
    ExperienceEditorTipsComponent,
    ExperienceLoveSlideshowComponent,
    ExperienceBenefitsComponent,
    ExperienceMapComponent,
    ExperienceDetailsDialogComponent,
    ExperienceInsidersComponent,
    ExperienceSelfExploreDesktopComponent,
    ExperienceSelfExploreMobileComponent,
    SelfExploreModalComponent,
    ExperienceModalCardComponent,
    ExperienceInsidersGalleryComponent,
  ],
  imports: [
    MatMenuModule,
    CommonModule,
    ExperienceRoutingModule,
    FooterModule,
    MatDialogModule,
    MatIconModule,
    LoadModule,
    ResizeImagePipe,
    OpenConfirmationComponent,
    ButtonComponent,
    SwiperDirective,
    SwiperSlideDirective,
    TranslocoDirective,
    EssDatePipe,
    BenefitsBoxComponent,
    TagComponent,
  ],
  exports: [ExperienceComponent, ExperienceHeaderComponent],
  providers: [],
})
export class ExperienceModule {}
